"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const kute_js_1 = __importDefault(require("kute.js"));
const react_1 = require("react");
function SliderFillAnimation({ bpm, isPlaying }, ref) {
    const leftGradientBorder = (0, react_1.useRef)([]);
    const rightGradientBorder = (0, react_1.useRef)([]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        setOffset: (offset) => {
            (isFillingState()
                ? rightGradientBorder
                : leftGradientBorder).current.forEach(el => {
                el.setAttribute('offset', `${offset}%`);
            });
        },
    }));
    const isFillingState = () => {
        return rightGradientBorder.current[0].getAttribute('offset') !== '100%';
    };
    const getCurrentOffset = () => {
        return parseFloat(isFillingState()
            ? rightGradientBorder.current[0].getAttribute('offset')
            : leftGradientBorder.current[0].getAttribute('offset'));
    };
    (0, react_1.useEffect)(() => {
        const animationSpeed = 1 / (bpm / 60);
        const animationDuration = 1000 * animationSpeed;
        const animationStartPoint = getCurrentOffset();
        const tweensEndObject = { attr: { offset: '100%' } };
        const options = { duration: animationDuration, easing: 'easingCubicInOut' };
        const rightBorderTweens = kute_js_1.default.allTo(rightGradientBorder.current, tweensEndObject, options);
        const leftBorderTweens = kute_js_1.default.allTo(leftGradientBorder.current, tweensEndObject, options);
        const reset = kute_js_1.default.allTo([...rightGradientBorder.current, ...leftGradientBorder.current], { attr: { offset: '0%' } }, { duration: '0' });
        const leftover = kute_js_1.default.allFromTo(isFillingState()
            ? rightGradientBorder.current
            : leftGradientBorder.current, { attr: { offset: `${animationStartPoint}%` } }, { attr: { offset: '100%' } }, { duration: (1 - animationStartPoint / 100) * animationDuration });
        leftover.chain(isFillingState() ? leftBorderTweens : reset);
        rightBorderTweens.chain(leftBorderTweens);
        leftBorderTweens.chain(reset);
        reset.chain(rightBorderTweens);
        if (isPlaying) {
            leftover.start();
        }
        return () => {
            rightBorderTweens.stop();
            leftBorderTweens.stop();
            reset.stop();
            leftover.stop();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPlaying, bpm]);
    return ((0, jsx_runtime_1.jsx)("defs", { "data-e2e": 'SliderFillAnimation_defs', children: (0, jsx_runtime_1.jsxs)("linearGradient", { id: "white-dash", x1: "0", x2: "1", "data-e2e": 'SliderFillAnimation_linearGradient', children: [(0, jsx_runtime_1.jsx)("stop", { offset: "0%", stopColor: "white", "data-e2e": 'SliderFillAnimation_stop' }), (0, jsx_runtime_1.jsx)("stop", { ref: (el) => (leftGradientBorder.current[0] = el), offset: "0%", stopColor: "white", "data-e2e": 'SliderFillAnimation_stop' }), (0, jsx_runtime_1.jsx)("stop", { ref: (el) => (leftGradientBorder.current[1] = el), offset: "0%", stopColor: "#4DBC96", "data-e2e": 'SliderFillAnimation_stop' }), (0, jsx_runtime_1.jsx)("stop", { ref: (el) => (rightGradientBorder.current[0] = el), offset: "0%", stopColor: "#4DBC96", "data-e2e": 'SliderFillAnimation_stop' }), (0, jsx_runtime_1.jsx)("stop", { ref: (el) => (rightGradientBorder.current[1] = el), offset: "0%", stopColor: "white", "data-e2e": 'SliderFillAnimation_stop' }), (0, jsx_runtime_1.jsx)("stop", { offset: "100%", stopColor: "white", "data-e2e": 'SliderFillAnimation_stop' })] }) }));
}
exports.default = (0, react_1.forwardRef)(SliderFillAnimation);
